import { BaseComponentProps } from '@utils/types/baseComponents';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import styles from './styles.module.scss';

type Props = {
  isHidden: boolean;
  weeklyPriceFactor: number;
  monthlyPriceFactor: number;
} & BaseComponentProps;

DiscountTextContainer.defaultProps = {
  isHidden: false,
  weeklyPriceFactor: 1,
  monthlyPriceFactor: 1,
};

export function DiscountTextContainer(props: Props) {
  const { containerStyle, isHidden, weeklyPriceFactor, monthlyPriceFactor } =
    props;

  const { weeklyDiscount, monthlyDiscount } = useMemo(
    () => ({
      weeklyDiscount: Math.round((1 - weeklyPriceFactor) * 100),
      monthlyDiscount: Math.round((1 - monthlyPriceFactor) * 100),
    }),
    [weeklyPriceFactor, monthlyPriceFactor]
  );

  if (isHidden) return null;

  if (weeklyDiscount && monthlyDiscount) {
    return (
      <div className={clsx([styles.discountTextContainer, containerStyle])}>
        <span className={styles.message}>
          <b>Save {weeklyDiscount}%</b> by booking for a week, or{' '}
          <b>save {monthlyDiscount}%</b> by booking for a month at this
          property.
        </span>
      </div>
    );
  }

  if (weeklyDiscount) {
    return (
      <div className={clsx([styles.discountTextContainer, containerStyle])}>
        <span className={styles.message}>
          <b>Save {weeklyDiscount}%</b> by booking for a week.
        </span>
      </div>
    );
  }

  if (monthlyDiscount) {
    return (
      <div className={clsx([styles.discountTextContainer, containerStyle])}>
        <span className={styles.message}>
          <b>Save {monthlyDiscount}%</b> by booking for a month at this
          property.
        </span>
      </div>
    );
  }

  return null;
}
